<script lang="ts">
	import "bulma/css/bulma.css";
	import Game from "./routes/game.svelte";
	import router from "page";

	let page;

	router("*", () => (page = Game));

	router.start();
</script>

<svelte:component this={page} />
